module.exports = __webpack_public_path__ + "img/Slice 268@2x.7484e536.png";